import React, { useEffect } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation
} from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";

// Page Components
import PeriodTracker from "./components/PeriodTracker";
import PregnancyProbabilityChecker from "./components/PregnancyProbabilityChecker";
import SafeDaysCalculator from "./components/SafeDaysCalculator";
import AverageDayCalculator from "./components/AverageDayCalculator";
import PregnancyTracker from "./components/PregnancyTracker";
import PregnancyDueDateEstimator from "./components/PregnancyDueDateEstimator";
import HormonalExerciseGuide from "./components/HormonalExerciseGuide";
import NutritionTips from "./components/NutritionTips";
import SafetyAwareness from "./components/SafetyAwareness";
import PregnancySafety from "./components/PregnancySafety";
import FAQSection from "./components/FAQSection";
import Footer from "./components/Footer";
import PrivacyPolicy from "./components/PrivacyPolicy";
import TermsOfService from "./components/TermsOfService";
import Home from "./pages/Home";
import AboutUs from "./pages/About";
import WellnessTips from "./components/WellnessTips";
import Header from "./components/Header";
import Blog from "./pages/Blog";

// Scroll to top on route change
const ScrollToTop = () => {
  const location = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [location.pathname]);
  return null;
};

// Page wrapper with animation
const PageWrapper = ({ children }) => (
  <motion.div
    initial={{ opacity: 0, y: 20 }}
    animate={{ opacity: 1, y: 0 }}
    exit={{ opacity: 0, y: -20 }}
    transition={{ duration: 0.4, ease: "easeInOut" }}
  >
    {children}
  </motion.div>
);

const AnimatedRoutes = () => {
  const location = useLocation();

  return (
    <AnimatePresence mode="wait">
      <Routes location={location} key={location.pathname}>
        <Route path="/" element={<PageWrapper><Home /></PageWrapper>} />
        <Route path="/period-tracker" element={<PageWrapper><PeriodTracker /></PageWrapper>} />
        <Route path="/pregnancy-probability" element={<PageWrapper><PregnancyProbabilityChecker /></PageWrapper>} />
        <Route path="/safe-days-calculator" element={<PageWrapper><SafeDaysCalculator /></PageWrapper>} />
        <Route path="/average-day-calculator" element={<PageWrapper><AverageDayCalculator /></PageWrapper>} />
        <Route path="/pregnancy-tracker" element={<PageWrapper><PregnancyTracker /></PageWrapper>} />
        <Route path="/due-date-estimator" element={<PageWrapper><PregnancyDueDateEstimator /></PageWrapper>} />
        <Route path="/hormonal-exercise" element={<PageWrapper><HormonalExerciseGuide /></PageWrapper>} />
        <Route path="/wellness-tips" element={<PageWrapper><WellnessTips /></PageWrapper>} />
        <Route path="/nutrition-tips" element={<PageWrapper><NutritionTips /></PageWrapper>} />
        <Route path="/safety-awareness" element={<PageWrapper><SafetyAwareness /></PageWrapper>} />
        <Route path="/pregnancy-safety" element={<PageWrapper><PregnancySafety /></PageWrapper>} />
        <Route path="/faq" element={<PageWrapper><FAQSection /></PageWrapper>} />
        <Route path="/privacy-policy" element={<PageWrapper><PrivacyPolicy /></PageWrapper>} />
        <Route path="/terms-of-service" element={<PageWrapper><TermsOfService /></PageWrapper>} />
        <Route path="/aboutus" element={<PageWrapper><AboutUs /></PageWrapper>} />
        <Route path="/blog" element={<PageWrapper><Blog /></PageWrapper>} />
      </Routes>
    </AnimatePresence>
  );
};

const App = () => {
  return (
    <Router>
      <Header/>
      <ScrollToTop />
      <AnimatedRoutes />
      <Footer />
    </Router>
  );
};

export default App;
